(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("remove-old-furniture");
  const hiddenInput = document.querySelector(".remove-old-furniture");
  const productCategory = document.querySelector(".round-checkbox-wrapper")?.dataset.category == 'Beds & Bed Frames' ? 'bed' : 'furniture';
  
  checkbox?.addEventListener("change", function () {
    if (this.checked) {
      hiddenInput.value = `Remove old ${productCategory}`;
    } else {
      hiddenInput.value = "";
    }
  });

  // Add click event listener to js-removal element to toggle filter-active class
  const removalElement = document.querySelector(".js-removal");
  removalElement?.addEventListener("click", function () {
    this.classList.toggle("active-filter");
  });

  // Intercept form submission to add removal product when active-filter class is present
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      // Check if js-removal has active-filter class
      if (removalElement && removalElement.classList.contains('active-filter')) {
        e.preventDefault(); // Prevent default form submission
        
        // Get the main product data
        const formData = new FormData(this);
        const mainProductId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        
        // Prepare items array with main product
        const items = [{
          id: parseInt(mainProductId),
          quantity: parseInt(quantity)
        }];
        
        // Add removal product if it exists
        const removalProductId = removalElement.dataset.removalProductId;
        if (removalProductId) {
          items.push({
            id: parseInt(removalProductId),
            quantity: 1
          });
        }
        
        // Submit to cart
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(response => response.json())
        .then(data => {
          // Show success message
          const successMessage = document.querySelector(".js-added-to-cart");
          if (successMessage) {
            successMessage.classList.remove("hidden");
            setTimeout(() => {
              successMessage.classList.add("hidden");
            }, 2000);
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      }
    });
  }


  //get product collections names
    const productCollectionsNames = document.querySelector(".product-collections");
    if (productCollectionsNames) {
      productCollectionsNames.forEach(name => {
        console.log(name);
      });
    }



});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }
    
    // Read collection from data attribute (if set)
    var collection = productRecommendationsSection.dataset.collection;
    
    // If a collection is set, don't make AJAX request as we already have the correct products
    if (collection) {
      // Just initialize the cursor effects and quantity handlers for collection-based recommendations
      setTimeout(function () {
        handleQtyChange();
      }, 500);
      setTimeout(function () {
        window.gsapCustomCursor();
      }, 500);
      return;
    }
    
    // Only make AJAX request for default recommendations (no collection set)
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    // Read limit from data attribute
    var limit = parseInt(productRecommendationsSection.dataset.limit, 10) || 6;
    // Build request URL
    var requestUrl = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit;
    
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML =
          container.querySelector('.product-recommendations').innerHTML;
        window.customHandleCursorEffect();
      }
    };
    document.addEventListener('DOMContentLoaded', function () {});
    request.send();
    setTimeout(function () {
      handleQtyChange();
    }, 500);
    setTimeout(function () {
     window.gsapCustomCursor();
    }, 500);
  };
  // Listen for changes done in the Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  function handleQtyChange() {
    document.querySelectorAll('.product-buttons').forEach((productButton) => {
      const minusBtn = productButton.querySelector('.qty-btn.minus');
      const plusBtn = productButton.querySelector('.qty-btn.plus');
      const visibleInput = productButton.querySelector('input[name="quantity"]');
      const hiddenInput = productButton.querySelector('form input[name="quantity"]');
      const updateQuantity = (change) => {
        let currentValue = parseInt(visibleInput.value, 10) || 1;
        let newValue = currentValue + change;
        if (newValue < 1) newValue = 1;
        visibleInput.value = newValue;
        hiddenInput.value = newValue;
      };
      minusBtn.addEventListener('click', () => updateQuantity(-1));
      plusBtn.addEventListener('click', () => updateQuantity(1));
      visibleInput.addEventListener('input', () => {
        let newValue = parseInt(visibleInput.value, 10) || 1;
        if (newValue < 1) newValue = 1;
        visibleInput.value = newValue;
        hiddenInput.value = newValue;
        if (visibleInput.value > 99) {
          visibleInput.style.maxWidth = '40px';
        } else {
          visibleInput.style.maxWidth = '30px';
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('.collection-slider .js-slider-prev').addEventListener('mouseenter', function () {
    const customCursor = document.querySelector('.collection-slider .custom-cursor');
    if (customCursor) {
      customCursor.innerHTML = `
      <svg
        class="left-arrow" 
        fill="#000000"
        width="25px"
        height="25px"
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon points="15.3 23.9 3.4 12 15.3 0.1 18.2 2.9 9.1 12 18.2 21.1 15.3 23.9"/>
      </svg>
    `;
    }
  });
  document.querySelector('.collection-slider .js-slider-next').addEventListener('mouseenter', function () {
    const customCursor = document.querySelector('.collection-slider .custom-cursor');
    if (customCursor) {
      customCursor.innerHTML = `
      <svg
        class="left-arrow scale-[-1]" 
        fill="#000000"
        width="25px"
        height="25px"
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon points="15.3 23.9 3.4 12 15.3 0.1 18.2 2.9 9.1 12 18.2 21.1 15.3 23.9"/>
      </svg>
    `;
    }
  });
  if (window.innerWidth > 1024) {
    document.querySelector('.swiper-navigation').remove();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-process"] && !Shopify.designMode) return;
  try {
    
  class SectionProcess extends HTMLElement {
    constructor() {
      super();
      this.zIndexClass    = "z-40";
      const swiperElement = this.querySelector(".process-swiper");

      this.handleCarousel(swiperElement);
    }

    handleCarousel(swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1.8,
        initialSlide: 0,
        centeredSlides: true,
        loop: false,
        // init: false,
        // noSwiping: true,
      });

      swiper.init();
    }
  }
  if(window.innerWidth < 1025) {
    customElements.define('section-process', SectionProcess);
    const processLinks = document.querySelectorAll(".process-link");

    if (processLinks[0]) {
      processLinks[0].classList.remove("active");
    }

    // Prevent # links from jumping to top on mobile
    processLinks.forEach(link => {
      if (link.getAttribute('href') === '#') {
        link.addEventListener('click', function(e) {
          e.preventDefault();
        });
      }
    });
  }
  document.addEventListener("DOMContentLoaded", function () {
    const processLinks = document.querySelectorAll(".process-link");
    const processDescriptions = document.querySelectorAll(".process-description");

    function updateDescriptions() {
        if (window.innerWidth < 1025) {
            processLinks.forEach((link, index) => {
                if (link.classList.contains("swiper-slide-active")) {
                    processDescriptions.forEach(desc => desc.classList.add("hidden"));
                    processDescriptions[index].classList.remove("hidden");
                }
            });
        } else {
            processLinks.forEach((link, index) => {
                link.removeEventListener("mouseenter", handleHover);
                link.addEventListener("mouseenter", handleHover);
                link.addEventListener('click', function(e) {
                  e.preventDefault();
                })
            });
        }
    }

    function handleHover(event) {
        processLinks.forEach(link => link.classList.remove("active"));
        event.currentTarget.classList.add("active");
        const index = Array.from(processLinks).indexOf(event.currentTarget);
        processDescriptions.forEach(desc => desc.classList.add("hidden"));
        processDescriptions[index].classList.remove("hidden");
    }

    updateDescriptions();
    window.addEventListener("resize", updateDescriptions);
    const observer = new MutationObserver(updateDescriptions);
    processLinks.forEach(link => {
        observer.observe(link, { attributes: true, attributeFilter: ["class"] });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-projects-slider"] && !Shopify.designMode) return;
  try {
    

class ProjectsSlider extends HTMLElement {
  constructor() {
    super();
    this.zIndexClass = 'z-40';
    const swiperElement = this.querySelector('.projects-swiper');

    this.handleCarousel(swiperElement);
    this.initializeGalleries();
  }

  connectedCallback() {
    
  }

  handleCarousel(swiperElement) {
    const swiper = new Swiper(swiperElement, {
      loop: true,
      slidesPerView: 1.2,
      centeredSlides: false,
      preventInteractionOnTransition: true,
      init: false,
      navigation: {
        nextEl: '.project-right',
        prevEl: '.project-left',
      },
      breakpoints: {
        768: {
          centeredSlides: true,
          slidesPerView: 1.4,
        },
        1441: {
          centeredSlides: true,
          slidesPerView: 1.74,
        },
      },
    });

    // FIX THE SWIPER LOOP BUG
    // https://github.com/nolimits4web/swiper/issues/7239
    // Find all slides
    const slides = this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicated)');

    // Clone all slides, add a class, and put them at the end
    slides.forEach((slide) => {
      const clonedSlide = slide.cloneNode(true); // Copy the slide
      clonedSlide.classList.add('swiper-slide-duplicated'); // Add the class
      this.querySelector('.swiper-wrapper').appendChild(clonedSlide); // Add the clone
    });

    swiper.on("transitionEnd", () => {
      // Re-initialize galleries for cloned slides
      this.initializeGalleries();
    });

    swiper.init();
  }

  initializeGalleries() {
    // Remove existing event listeners to prevent duplicates
    const galleryTriggers = this.querySelectorAll('.gallery-trigger');
    
    galleryTriggers.forEach(trigger => {
      // Remove existing listener if any
      trigger.removeEventListener('click', this.handleGalleryClick);
      
      // Add new listener
      if (trigger.dataset.hasGallery === 'true') {
        trigger.addEventListener('click', this.handleGalleryClick.bind(this));
      }
    });
  }

  handleGalleryClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    
    const trigger = evt.currentTarget;
    const galleryData = trigger.dataset.galleryImages;
    
    if (galleryData) {
      try {
        const gallery = JSON.parse(galleryData);
        
        // Filter out empty images
        const validImages = gallery.filter(img => img.src && img.src.trim() !== '');
        
        if (validImages.length > 0) {
          Spotlight.show(validImages, {
            onshow: function(index) {
              console.log('Gallery opened at index:', index);
            },
            onclose: function() {
              console.log('Gallery closed');
            }
          });
        }
      } catch (error) {
        console.error('Error parsing gallery data:', error);
      }
    }
  }
}

customElements.define('projects-slider', ProjectsSlider);

  } catch(e) { console.error(e); }
})();
})();
